import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { logout } from "shared/helpers/auth-functions";
import { RootStateOrAny } from "react-redux";
import {
  fetchLoggedUser,
  fetchPersonifiedUser,
} from "shared/service/StrmService";
import { getBrowserId } from "shared/helpers/browser-id";
import { dataLayerEventAcesso } from "event-tracker/gtm-events";
import { DEFAULT_LANG } from "shared/constants/LocalStorageConsts";
import { Usuario } from "shared/interfaces/Usuario";

export const getLoggedUser = createAsyncThunk("users/GetUser", async () => {
  const loggedUser: any = await fetchLoggedUser(getBrowserId());
  if (loggedUser.emailPersonified) return await fetchPersonifiedUser();
  return loggedUser;
});

export type UserState = {
  users: {
    loggedUser: Usuario;
    loading: boolean;
    isAdminStrm: boolean;
  };
};

export const usersSlice = createSlice({
  name: "users",
  initialState: {
    loggedUser: {
      isAdminStrm: false,
      currentLanguage: DEFAULT_LANG,
      actions: {},
    },
    loading: true,
  },
  reducers: {},
  extraReducers: {
    [getLoggedUser.fulfilled.type]: (state, action) => {
      if (action.payload) {
        state.loggedUser = action.payload;
        state.loading = false;
        dataLayerEventAcesso(action.payload);
      } else {
        logout(true);
      }
    },
    [getLoggedUser.pending.type]: (state) => {
      state.loading = true;
    },
  },
});

export const selectLoggedUser = (state: RootStateOrAny) => state.loggedUser;

export default usersSlice.reducer;
